<template>
  <b-container>
    <b-row>
      <b-col class="m-3">
        <b-card class="w-100 shadow" :title="(isAdd) ? 'ایجاد مستند' : 'ویرایش مستند'">
          <b-overlay :show="loading" rounded opacity="0.6" spinner-large spinner-variant="info"
            class="d-inline-block w-100" @hidden="!loading">
            <b-row>
              <b-col md="3">
                <p class="text-right w-100 mt-3">کد مرجع</p>
                <p class="text-secondary font-weight-bolder">{{ document.code }}</p>
              </b-col>
              <b-col md="9">
                <label for="input_title" class="text-right w-100 mt-3 required-label">عنوان</label>
                <b-form-input type="text" v-model="document.title" id="input_title" placeholder="ورود عنوان سند"
                  class="rtl"></b-form-input>
              </b-col>
              <b-col md="12">
                <p class="mt-3 text-right w-100 required-label">متن</p>
                <ckeditor :editor="ckeditor.editor" v-model="document.content" :config="ckeditor.editorConfig">
                </ckeditor>
              </b-col>
              <b-col md="12">
                <label for="input_topics" class="text-right w-100 mt-3 required-label">سرفصل ها</label>
                <multiselect id="input_topics" v-model="selectTopics.selected" :options="selectTopics.options"
                  :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                  selectLabel="فشردن Enter برای انتخاب" selectedLabel="انتخاب شده"
                  deselectLabel="فشردن Enter برای رد انتخاب" noOptions="موردی یافت نشد"
                  :custom-label="({ title }) => title" :placeholder="selectTopics.first" label="title" track-by="title">
                </multiselect>
              </b-col>
              <b-col md="12">
                <label for="input_keywords" class="text-right w-100 mt-3 required-label">کلیدواژه ها</label>
                <multiselect id="input_keywords" v-model="selectKeywords.selected" :options="selectKeywords.options"
                  :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                  selectLabel="فشردن Enter برای انتخاب" selectedLabel="انتخاب شده"
                  deselectLabel="فشردن Enter برای رد انتخاب" noOptions="موردی یافت نشد"
                  :custom-label="({ name }) => name" :placeholder="selectKeywords.first" label="name" track-by="name">
                </multiselect>
              </b-col>
              <b-col md="12">
                <label for="input_references" class="text-right w-100 mt-3 required-label">منابع</label>
                <multiselect id="input_references" v-model="selectReferences.selected"
                  :options="selectReferences.options" :multiple="true" :close-on-select="false" :clear-on-select="false"
                  :preserve-search="true" selectLabel="فشردن Enter برای انتخاب" selectedLabel="انتخاب شده"
                  deselectLabel="فشردن Enter برای رد انتخاب" noOptions="موردی یافت نشد"
                  :custom-label="({ content_title, formated_jalali_held_at }) => content_title + ' (' + formated_jalali_held_at + ') '"
                  :placeholder="selectReferences.first" label="content_title" track-by="content_title"></multiselect>
              </b-col>
              <b-col md="12">
                <p class="mt-3 text-right w-100">آپلود ضمیمه</p>
                <b-form-file class="text-center" v-model="inputAttachmentFiles" multiple
                  drop-placeholder="اینجا رها کنید" placeholder="فایلی را انتخاب کنید یا در اینجا رها کنید"
                  browse-text="انتخاب فایل" @input="uploadAttachmentFiles"></b-form-file>
                <b-list-group :key="attachmentFilesKey"
                  v-if="Array.isArray(attachmentFiles) && attachmentFiles.length > 0" class="mt-2">
                  <b-list-group-item v-for="(attachmentFile, index) in attachmentFiles" :key="index"
                    class="p-2 rtl text-right" :disabled="!attachmentFile.url">
                    <b-img v-show="attachmentFile.mimeType && attachmentFile.mimeType.startsWith('image')"
                      :src="attachmentFile.url" thumbnail fluid class="w-25"></b-img>
                    <a :href="attachmentFile.url" class="d-block w-100 ltr text-center" target="_blank"
                      rel="noopener noreferrer">{{ attachmentFile.originalName }}</a><br>
                    {{ attachmentFile.desc }} <b-button pill variant="outline-danger" size="sm"
                      @click="dropAttachment(index)">
                      <b-icon icon="trash"></b-icon>
                    </b-button>
                  </b-list-group-item>
                </b-list-group>
              </b-col>

            </b-row>

            <b-button variant="info" class="mx-auto w-25 mt-5" @click="doAddOrEdit" :disabled="loading">
              <span v-if="isAdd">ایجاد</span>
              <span v-else>ثبت</span>
            </b-button>
            <b-button variant="outline-info" class="mx-auto mt-5" @click="$router.go(homeIndex)" :disabled="loading">
              بازگشت
            </b-button>
          </b-overlay>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import _ from 'lodash'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import humanize from '../../utils/humanize'

export default {
  name: 'DocumentAddEdit',
  data: () => ({
    ckeditor: {
      editor: ClassicEditor,
      editorConfig: {
        contentsLangDirection: 'rtl',
        language: 'fa'
      }
    },
    loading: false,
    isAdd: true,
    homeIndex: -1,
    document_id: null,
    document: {
      code: null,
      reference_ids: [],
      keyword_ids: [],
      topic_ids: [],
      title: '',
      content: '',
      images: [],
      video: null,
    },
    selectKeywords: {
      options: [],
      selected: [],
      first: 'یک یا چند کلیدواژه انتخاب کنید'
    },
    selectTopics: {
      options: [],
      selected: [],
      first: 'یک یا چند سرفصل انتخاب کنید'
    },
    selectReferences: {
      options: [],
      selected: [],
      first: 'یک یا چند منبع انتخاب کنید'
    },
    inputAttachmentFiles: [],
    attachmentFiles: [],
    attachmentFilesKey: 0
  }),
  created() {
    if (this.$route.query.home_index) {
      this.homeIndex = parseInt(this.$route.query.home_index)
    }

    setTimeout(() => {
      this.fetchKeywords()
    }, 100)

    setTimeout(() => {
      this.fetchTopics()
    }, 200)

    setTimeout(() => {
      this.fetchReferences()
    }, 300)

    this.document_id = this.$route.params.document_id
    if (this.document_id) {
      this.isAdd = false

      this.loading = true
      this.$axios.get('/documents/' + this.document_id).then((response) => {
        const body = response.data

        this.document = _.pick(body.data, [
          'reference_ids', 'topic_id', 'keyword_id', 'title', 'content', 'code'
        ])

        this.selectKeywords.selected = (body.data.keywords) ? body.data.keywords : []
        this.selectTopics.selected = (body.data.topics) ? body.data.topics : []
        this.selectReferences.selected = (body.data.references) ? body.data.references : []

        if (Array.isArray(body.data.attachments) && body.data.attachments.length > 0 && Array.isArray(body.data.attachment_urls) && body.data.attachment_urls) {
          this.attachmentFiles = []
          for (let n = 0; n < body.data.attachments.length; n++) {
            const attachment = body.data.attachments[n];
            this.attachmentFiles.push({
              originalName: attachment.original_name | attachment.name,
              desc: `نام: ${attachment.original_name | attachment.name}`,
              url: body.data.attachment_urls[n],
              self: attachment.name,
              mimeType: attachment.mimeType
            })
          }
        }
      }).catch((err) => {
        this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
      }).finally(() => {
        this.loading = false
      })
    } else {
      this.loading = true
      this.$axios.get('/documents/next-code').then((response) => {
        const body = response.data
        this.document.code = body.data.code
      }).finally(() => {
        this.loading = true
      })
    }
  },
  methods: {
    uploadAttachmentFiles() {
      if (this.inputAttachmentFiles.length <= 0) {
        return
      }
      this.loading = true
      this.$bvToast.toast('کمی صبر کنید', { variant: 'info', title: 'در حال آپلود فایل' })
      this.inputAttachmentFiles.forEach(inputAttachmentFile => {
        this.attachmentFiles.push({
          originalName: inputAttachmentFile.name,
          desc: `نام: ${inputAttachmentFile.name}، حجم: ${humanize.filesize(inputAttachmentFile.size)}`,
          url: null,
          self: null,
          mimeType: inputAttachmentFile.type
        })
      });

      for (let n = 0; n < this.inputAttachmentFiles.length; n++) {
        const inputAttachmentFile = this.inputAttachmentFiles[n];

        let formData = new FormData()
        formData.append('file', inputAttachmentFile)

        this.$axios.post('/uploads/document-attachments', formData).then((response) => {
          const body = response.data

          for (let i = 0; i < this.attachmentFiles.length; i++) {
            const imageFile = this.attachmentFiles[i];
            if (imageFile.originalName == body.data.requested_file_original_name) {
              this.attachmentFiles[i]['url'] = body.data.file_url
              this.attachmentFiles[i]['self'] = body.data.file
            }
          }
          this.$bvToast.toast('فایل ضمیمه با موفقیت آپلود شد', { variant: 'success', title: 'هورا' })
        }).catch((err) => {
          this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
          _.remove(this.attachmentFiles, (afElem) => _.map(this.inputAttachmentFiles, 'name').includes(afElem.originalName))
        }).finally(() => {
          this.loading = false
          this.inputAttachmentFiles = []
        })
      }
    },
    dropAttachment(index) {
      _.pullAt(this.attachmentFiles, [index])
      this.attachmentFilesKey += 1
    },
    fetchKeywords() {
      this.loading = true
      this.$axios.get('/keywords', {
        params: {
          limit: -1,
          page: 1,
          select: 'tiny'
        }
      }).then((response) => {
        const body = response.data

        this.selectKeywords.options = body.data
      }).finally(() => {
        this.loading = false
      })
    },
    fetchTopics() {
      this.loading = true
      this.$axios.get('/topics', {
        params: {
          limit: -1,
          page: 1,
          select: 'tiny'
        }
      }).then((response) => {
        const body = response.data

        this.selectTopics.options = body.data
      }).finally(() => {
        this.loading = false
      })
    },
    fetchReferences() {
      this.loading = true
      this.$axios.get('/references', {
        params: {
          limit: -1,
          page: 1,
          select: 'tiny_with_held_at'
        }
      }).then((response) => {
        const body = response.data

        this.selectReferences.options = body.data
      }).finally(() => {
        this.loading = false
      })
    },
    doAddOrEdit() {
      this.document.reference_ids = (Array.isArray(this.selectReferences.selected)) ? _.map(this.selectReferences.selected, '_id') : []
      this.document.keyword_ids = (Array.isArray(this.selectKeywords.selected)) ? _.map(this.selectKeywords.selected, '_id') : []
      this.document.topic_ids = (Array.isArray(this.selectTopics.selected)) ? _.map(this.selectTopics.selected, '_id') : []

      if (!Array.isArray(this.document.reference_ids) || (Array.isArray(this.document.reference_ids) && this.document.reference_ids.length < 1)) {
        return this.$bvToast.toast('انتخاب یک یا چند منبع الزامی است', { variant: 'danger', title: 'خطا' })
      }

      if (!Array.isArray(this.document.topic_ids) || (Array.isArray(this.document.topic_ids) && this.document.topic_ids.length < 1)) {
        return this.$bvToast.toast('انتخاب یک یا چند سرفصل الزامی است', { variant: 'danger', title: 'خطا' })
      }

      if (!Array.isArray(this.document.keyword_ids) || (Array.isArray(this.document.keyword_ids) && this.document.keyword_ids.length < 1)) {
        return this.$bvToast.toast('انتخاب یک یا چند کلیدواژه الزامی است', { variant: 'danger', title: 'خطا' })
      }

      if (this.document.title == "" || !this.document.title) {
        return this.$bvToast.toast('فیلد عنوان الزامی است', { variant: 'danger', title: 'خطا' })
      }

      if (this.document.content == "" || !this.document.content) {
        return this.$bvToast.toast('فیلد متن الزامی است', { variant: 'danger', title: 'خطا' })
      }

      if (this.attachmentFiles && Array.isArray(this.attachmentFiles) && this.attachmentFiles.length > 0) {
        this.document.attachments = _.map(this.attachmentFiles, (attachmentFile) => {
          if (attachmentFile.self) {
            return {
              name: attachmentFile.self,
              mimetype: attachmentFile.mimeType,
              original_name: attachmentFile.originalName
            }
          }
        })
      }

      this.loading = true
      if (this.isAdd) {
        this.$axios.post('/documents', this.document).then((response) => {
          if (response.status == 208) { //means duplicate content
            const body = response.data
            this.$bvToast.toast(
              'مستند فوق تکراری است، می توانید آن را ویرایش کنید',
              { variant: 'warning', title: 'هورا', href: this.$router.resolve({ name: 'EditDocument', params: { document_id: body.data._id }, query: { home_index: -2 } }).href }
            )
          } else {
            this.$bvToast.toast('مستند با موفقیت ایجاد شد', { variant: 'success', title: 'هورا' })
            this.$router.go(this.homeIndex)
          }
        }).catch(err => {
          this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$axios.put('/documents/' + this.document_id, this.document).then((response) => {
          if (response.status == 208) { //means duplicate content
            const body = response.data
            this.$bvToast.toast(
              'مستند فوق تکراری است، می توانید آن را ویرایش کنید',
              { variant: 'warning', title: 'توجه', href: this.$router.resolve({ name: 'EditDocument', params: { document_id: body.data._id }, query: { home_index: -2 } }).href }
            )
          } else {
            this.$bvToast.toast('مستند با موفقیت ویرایش شد', { variant: 'success', title: 'هورا' })
            this.$router.go(this.homeIndex)
          }
        }).catch(err => {
          this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>